import { BaseModel } from './base';

export class ProductBrand extends BaseModel {
  idProductBrand!: number;

  override objectID(): string | null {
    return this.idProductBrand?.toString() ?? null;
  }
}
